import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDiscreetInformatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M30.04 30H10V14l4 2 4-6 4 8 4-6 4 6z"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M8.5 31.5V8h-1v24.5H32v-1z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M35.26 23.77a1 1 0 0 0-1.27.69c-.23.81-.47 1.58-.63 2.12l-.15.49a.64.64 0 0 1-.87.17c-.38-.27-.38-1-.37-1.51V18a1 1 0 1 0-2 0v7a.33.33 0 0 1-.31.35.33.33 0 0 1-.3-.35v-8.32a1 1 0 1 0-2 0V25a.33.33 0 0 1-.31.35.33.33 0 0 1-.3-.35v-7.6a1 1 0 1 0-2 0v8.48a.33.33 0 0 1-.31.34.32.32 0 0 1-.3-.34v-4.21a1 1 0 1 0-2 0v8.82q-.015.13 0 .26A6.14 6.14 0 0 0 34 31.91l2-6.69a1.17 1.17 0 0 0-.64-1.45z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.29 29.25V24h1v5.313l-.004.033a.3.3 0 0 0 0 .088v.006a4.62 4.62 0 0 0 4.702 4.06l.024 1a5.62 5.62 0 0 1-5.718-4.937 1.3 1.3 0 0 1-.004-.312"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDiscreetInformatie);

export default ForwardRef;
